module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center pl1",
    staticStyle: {
      "border-bottom": "1px solid rgba(0, 0, 0, 0.12)"
    }
  }, [_c('div', {
    staticClass: "flex ma3",
    class: {
      'toggle-side-bar': _vm.hovered
    },
    on: {
      "mouseenter": function($event) {
        _vm.hovered = true
      },
      "mouseleave": function($event) {
        _vm.hovered = false
      },
      "click": _vm.toggleSideBarVisibility
    }
  }, [_c('div', {
    staticClass: "customize-tooltip"
  }, [(!_vm.hovered && !_vm.getCourseLayoutFullScreenStatus) ? _c('img', {
    attrs: {
      "src": "/static/logos/collapse_black.svg",
      "alt": "hide"
    }
  }) : (_vm.hovered && !_vm.getCourseLayoutFullScreenStatus) ? _c('img', {
    attrs: {
      "src": "/static/logos/collapse_blue.svg",
      "alt": "hide"
    }
  }) : (!_vm.hovered && _vm.getCourseLayoutFullScreenStatus) ? _c('img', {
    attrs: {
      "src": "/static/logos/expand_black.svg",
      "alt": "hide"
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/logos/expand_blue.svg",
      "alt": "hide"
    }
  }), _vm._v(" "), (_vm.hovered) ? _c('div', [_vm._v("\n        " + _vm._s(_vm.getCourseLayoutFullScreenStatus ? 'expand' : 'collapse') + "\n      ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center ml2",
    staticStyle: {
      "flex": "3",
      "height": "100%",
      "max-width": "60%"
    }
  }, [_c('edit-title-inline')], 1), _vm._v(" "), _c('div', {
    staticClass: "live-discussion-optional-btn-row flex",
    staticStyle: {
      "flex": "1"
    }
  }, [_c('div', {
    staticClass: "flex flex-nowrap items-center",
    staticStyle: {
      "margin-left": "auto"
    }
  }, [(
    _vm.getCurrentDiscussion.points_settings.peer_rewards.length &&
    !_vm.hasTeacherPermissionsInCourse
  ) ? _c('point-descriptions', {
    staticClass: "pl-subheading dib",
    attrs: {
      "rewards": _vm.getCurrentDiscussion.points_settings.peer_rewards,
      "criteriaScale": Number(_vm.getCurrentDiscussion.point_cap)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showQuestionIcon) ? _c('div', {
    staticClass: "clickable firstRT-welcome-tutorial",
    on: {
      "click": function($event) {
        return _vm.$emit('showRountableWelcomeModal')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-question"
  })]) : _vm._e(), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse) ? _c('pl-button', {
    staticClass: "invite-button-custom pv1 clickable ripple mr2 flex items-center nav-rt-button",
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('showShareActivityModal')
      }
    }
  }, [_vm._v("\n        INVITE\n      ")]) : _vm._e(), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse) ? _c('pl-button', {
    staticClass: "summary-button pv1 clickable ripple mr2 flex items-center nav-rt-button",
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('goToSummaryPage')
      }
    }
  }, [_vm._v("\n        SUMMARY\n      ")]) : _vm._e(), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse) ? _c('pl-menu', {
    attrs: {
      "menuSize": 5,
      "direction": "right"
    }
  }, [_c('pl-button', {
    staticClass: "pl-icon nav-bar-btn",
    staticStyle: {
      "margin": "0 16px"
    },
    attrs: {
      "slot": "menu_trigger"
    },
    slot: "menu_trigger"
  }, [_c('i', {
    staticClass: "fas fa-ellipsis-v"
  })]), _vm._v(" "), _c('ul', {
    attrs: {
      "menu-content": ""
    }
  }, [_c('li', {
    on: {
      "click": _vm.addToUniverse
    }
  }, [_c('span', [_vm._v("Add to Universe")]), _vm._v(" "), _c('img', {
    staticClass: "ml1",
    staticStyle: {
      "width": "16px"
    },
    attrs: {
      "src": "/static/logos/universe_logo.svg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.show_export_data_modal = true
      }
    }
  }, [_c('span', [_vm._v("Export Data")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-download"
  })]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.showDuplicateModal
    }
  }, [_c('span', [_vm._v(" Duplicate RoundTable ")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-files-o"
  })]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.openSentencesStemsSettings()
      }
    }
  }, [_c('span', [_vm._v("Edit Sentence Stems")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/ld-sentence-stems.svg"
    }
  })]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.$emit('editAssessment')
      }
    }
  }, [_c('span', [_vm._v("Edit Assessment Criteria")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-gear"
  })]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.syncAssessment
    }
  }, [_c('span', [_vm._v(" Sync Assessment ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/sync.svg"
    }
  })]), _vm._v(" "), _c('li', {
    staticStyle: {
      "color": "#e53935"
    },
    on: {
      "click": function($event) {
        _vm.show_delete_live_rt_modal = true
      }
    }
  }, [_c('span', [_vm._v("Delete Discussion")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-trash"
  })])])], 1) : _vm._e()], 1)]), _vm._v(" "), (_vm.show_delete_live_rt_modal) ? _c('pl-confirm', {
    attrs: {
      "confirmColor": "bg-red-500",
      "confirmText": "DELETE"
    },
    on: {
      "close": function($event) {
        _vm.show_delete_live_rt_modal = false
      },
      "confirm": _vm.deleteLiveRoundtable
    }
  }, [_c('div', {
    staticClass: "ma4 tl ph4 pl-subheading"
  }, [_c('p', {
    staticClass: "ma0"
  }, [_vm._v("\n        You are deleting "), _c('strong', [_vm._v(_vm._s(_vm.getCurrentDiscussion.title) + ".")])]), _vm._v(" "), _c('p', {
    staticClass: "pl-body-1 ma0 italics"
  }, [_vm._v("\n        This cannot be undone and student data will be lost forever.\n      ")])])]) : _vm._e(), _vm._v(" "), (_vm.show_export_data_modal) ? _c('ExportEngagementDataModal', {
    attrs: {
      "fileName": _vm.exportable_file_name,
      "getFile": _vm.fetchClassCSVdata,
      "showButtons": Boolean(_vm.getCurrentDiscussion.participations.length)
    },
    on: {
      "close": function($event) {
        _vm.show_export_data_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_guiding_questions_modal) ? _c('pl-dialog', {
    on: {
      "close": function($event) {
        _vm.show_guiding_questions_modal = false
      }
    }
  }, [_c('pl-button', {
    staticClass: "pl-icon",
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "right": "0"
    },
    nativeOn: {
      "click": function($event) {
        _vm.show_guiding_questions_modal = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })]), _vm._v(" "), _c('div', {
    staticClass: "pl-title"
  }, [_c('strong', [_vm._v("Guiding Questions")])]), _vm._v(" "), _c('div', {
    staticClass: "pl-caption mb4"
  }, [_vm._v("(seen on student notepad)")]), _vm._v(" "), _c('div', {
    ref: "guiding_questions_container",
    staticClass: "mt3 tl guiding-questions-container"
  }, _vm._l((_vm.getCurrentDiscussion.guiding_questions), function(question, index) {
    return _c('div', {
      staticClass: "mv3 pl-subheading",
      staticStyle: {
        "position": "relative"
      }
    }, [_c('div', {
      staticStyle: {
        "overflow-wrap": "break-word"
      }
    }, [_vm._v("\n          " + _vm._s(index + 1) + ". " + _vm._s(question) + "\n        ")]), _vm._v(" "), _c('pl-button', {
      staticClass: "pl-icon",
      staticStyle: {
        "position": "absolute",
        "right": "-30px",
        "top": "0",
        "margin-top": "-5px"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.deleteGuidanceQuestion(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-close"
    })])], 1)
  }), 0), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row middle-xs center-xs"
  }, [_c('pl-input', {
    staticClass: "col-xs-8",
    attrs: {
      "type": "text",
      "labelText": "",
      "maxLength": 255
    },
    model: {
      value: (_vm.new_guiding_question),
      callback: function($$v) {
        _vm.new_guiding_question = $$v
      },
      expression: "new_guiding_question"
    }
  }), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-primary pl-icon",
    nativeOn: {
      "click": function($event) {
        return _vm.createNewGuidingQuestion.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-05cb4a28!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/liveDiscussion/components/discussionCircleNavBar.vue
// module id = 1744
// module chunks = 61